<template>
  <b-input-group class="group-telefones">
    <slot />
    <b-form-input
      class="mt-1"
      v-model="telefone_value"
      :size="size"
    ></b-form-input>

    <b-input-group-append class="mt-1" :size="size">
      <b-form-checkbox
        v-model="telefone.whatsapp"
        class="social-button whatsapp-icon"
        button
        :size="size"
      />

      <b-form-checkbox
        v-model="telefone.telegram"
        class="social-button telegram-icon"
        :class="{ 'checked-icon': telefone.telegram }"
        button
        :size="size"
      />

      <b-button
        v-b-tooltip.hover
        title="Remover número"
        variant="danger"
        @click="remove()"
        class="btn-remove-contato"
        :size="size"
      >
        <font-awesome-icon icon="trash" />
      </b-button>
    </b-input-group-append>

    <b-form-invalid-feedback>
      <span v-if="$v && !$v.telefone.value.numeric">Telefone inválido</span>
      <span v-if="$v && !$v.telefone.value.minLength"
        >Telefone deve ter no mínimo 8 caracteres</span
      >
    </b-form-invalid-feedback>
  </b-input-group>
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";

import { validationMixin } from "vuelidate";
import { minLength } from "vuelidate/lib/validators";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import telefoneFilter from "@/helpers/filters/telefone";

export default {
  mixins: [formControlMixin, formStateMixin, validationMixin],
  props: {
    ...makePropsConfigurable(
      sortKeys({
        ...formStateProps,
        ...formControlProps,
        value: {
          type: Object,
          default: {},
        },
        size: {
          type: String,
          default: "",
        },
      })
    ),
  },
  data: function () {
    return {
      telefone: this.value,
    };
  },
  computed: {
    telefone_value: {
      set(value) {
        // Mantém a lógica de armazenamento: salva valor limpo ou E.164
        let parsed = value;
        const onlyDigits = parsed ? parsed.replace(/\D/g, "") : "";
        if (parsed && !parsed.startsWith("+")) {
          if (parsed.startsWith("00")) {
            parsed = "+" + parsed.slice(2);
          } else if (/^0800/.test(onlyDigits)) {
            parsed = onlyDigits;
          } else if (/^\d{10,15}$/.test(onlyDigits)) {
            parsed = "+55" + onlyDigits;
          }
        }
        const phone = parsePhoneNumberFromString(parsed);
        if (phone) {
          this.telefone.value = phone.number;
        } else {
          this.telefone.value = parsed;
        }
      },
      get() {
        // Centraliza a formatação usando o filtro
        return telefoneFilter(this.telefone.value || "");
      },
    },
  },
  validations: {
    telefone: {
      value: {
        minLength: minLength(8), // aceita números curtos (fixos internacionais)
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.telefone[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.telefone.$touch();
      return !this.$v.telefone.$anyError;
    },
    remove() {
      this.$emit("remove");
    },
    blockUnexpectedCharacters: function ($event) {
      $event = $event ? $event : window.event;
      const charCode = $event.which ? $event.which : $event.keyCode;
      const isTextCharacters =
        charCode > 31 && (charCode < 48 || charCode > 57);

      if (isTextCharacters) {
        $event.preventDefault();
        return;
      }
    },
  },
  watch: {
    value: function (value) {
      this.telefone = value;
    },
  },
};
</script>

<style></style>
